/* ============================================================
   Alatreyu Product Page — Entrance Animations (IntersectionObserver)
   Staggered fade-in + slide-up for product info elements.
   Progressive enhancement: content is visible by default;
   animations only run when IntersectionObserver is supported.
   Replaces GSAP dependency (116KB saved).
   ============================================================ */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var infoSide = document.querySelector('.product-info-side');
  if (!infoSide) return;

  var targets = infoSide.querySelectorAll(
    '.product-title-row, .product-scent-notes, .product-description, ' +
    '.product-chooser__header, .product-chooser, .product-values'
  );

  if (!targets.length) return;

  /* Mark that animations are ready — CSS uses this to set initial hidden state */
  infoSide.classList.add('gsap-ready');

  /* Set initial hidden state */
  targets.forEach(function (t) {
    t.style.opacity = '0';
    t.style.transform = 'translateY(30px)';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      targets.forEach(function (t, i) {
        setTimeout(function () {
          t.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
          t.style.opacity = '1';
          t.style.transform = 'translateY(0)';
        }, 150 + i * 100);
      });
    });
  }, { threshold: 0.1 });

  observer.observe(infoSide);
})();
